import { Component, OnInit, OnDestroy, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import { PreguntasService } from '../_services/preguntas.service';

import { NgForm } from '@angular/forms';

import { GlobalEventsManager } from "../_services/globaleventsmanager.service";
import { NormasService } from '../_services/normas.service';
import { UsuariosService } from '../_services/usuarios.service';

import { Usuario } from '../_models/usuario.model';

import { AppSettings } from '../_models/settings.models'



declare var jQuery: any;

@Component({
  selector: 'usuario',
  templateUrl: 'usuario.template.html'
})
export class UsuarioComponent implements OnInit, OnDestroy, AfterViewInit {

  subscription: Subscription;
  usuario: Usuario;
  listaempresas: any = [];
  insertonuevo: boolean = false;

  fecha: Date;
  es: any;


  listaaccesos: any = [];
  public filterQuery = "";
  public filterQueryEvidencias = "";

  public filterQuery2 = "";

  listaaplicaciones: any = [];
  listaRoles: any = [];

  apikeytoken: string = AppSettings.API_KEYTOKEN;
  apiurl: string = AppSettings.API_URL;
  currentUserToken: string = localStorage.getItem('currentUserToken');

  @ViewChild('formreport') public formreport: ElementRef;

  constructor(private seguridad: SeguridadService,
    private router: Router,
    private normasService: NormasService,
    private usuariosService: UsuariosService,
    private globalEventsManager: GlobalEventsManager,
    private activatedRoute: ActivatedRoute) {


  }

  ngOnInit() {

    this.es = {
      firstDayOfWeek: 0,
      dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
      dayNamesShort: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
      dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
      monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
      monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"]
    };

    this.usuario = new Usuario();

    this.seguridad.getLogado();

    this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode) => {
      if (mode !== null) {
        if (!mode) {
          this.router.navigate(['login']);
        }
      }
    });

    this.globalEventsManager.menuExtendido(true);


    let breadcrumb: any = [
      {
        'path': '/usuarios',
        'name': 'Administración de usuarios'
      },
      {
        'path': '#',
        'name': 'Usuario'
      }];

    this.globalEventsManager.setNombrePagina(breadcrumb);

    let _id_usuario = this.activatedRoute.snapshot.params["id_usuario"];
    if (_id_usuario && _id_usuario != 0 && _id_usuario != 'nuevo') {
      this.getUsuario(_id_usuario);
    } else {
      this.nuevoUsuario();
    }

    this.getListaEmpresas();

  }

  ngAfterViewInit() {

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  nuevoUsuario() {
    this.insertonuevo = true;
    this.usuario.nombre = "Nuevo";
    this.usuario.apellidos = "Usuario";
    this.usuario.sessionexpiretime = 180;
  }

  getUsuario(id_usuario: number) {
    this.usuariosService.getUsuario(id_usuario).subscribe(
      data => {
        if (data) {
          this.updateUsuario(data.json().usuario);
          this.getListaAccesos();
          this.getListaRoles();
        }
      }
    );
  }

  getReport() {

    this.formreport.nativeElement.submit();

  }

  getListaRoles() {
    this.usuariosService.getListaRoles().subscribe(
      data => {
        if (data) {
          this.listaRoles = data.json().lista;
          
        }
      }
    );

  }

  setListaRoles(id_role) {
    this.usuariosService.setListaRoles(id_role).subscribe(
      data => {
        if (data) {
          
          
        }
      }
    );

  }

  getListaEmpresas() {
    this.usuariosService.getListaEmpresas().subscribe(
      data => {
        if (data) {
          this.listaempresas = data.json().lista;
          
        }
      }
    );
  }

  getListaAccesos() {
    this.usuariosService.getListaAccesos(this.usuario.id_usuario).subscribe(
      data => {
        if (data) {
          this.listaaccesos = data.json().accesos;
          //console.log(this.listaaccesos);
          setTimeout(() => this.inicializarListaAccesos(), 500);
          this.getListaPermisos();
        }
      }
    );
  }

  getListaPermisos() {
    this.usuariosService.getListaPermisos(this.usuario.id_usuario).subscribe(
      data => {
        if (data) {
          this.listaaplicaciones = data.json().accesos;
          //console.log(this.listaaccesos);
          setTimeout(() => this.inicializarListaPermisos(), 500);
        }
      }
    );
  }

  updateUsuario(data) {
    console.log(data);
    this.usuario.nombre = data.nombre;
    this.usuario.apellidos = data.apellidos;
    this.usuario.activo = data.activo;
    this.usuario.email = data.email;
    this.usuario.id_empresa = data.id_empresa;
    this.usuario.id_usuario = data.id_user;
    this.usuario.telefono = data.telefono;
    this.usuario.sessionexpiretime = data.sessionexpiretime;
    this.usuario.allowip = data.allowip;
    this.usuario.password = "";
    this.usuario.passwordre = "";
    this.usuario.id_role = data.id_role;
  }

  modificarAcceso(item: any, id_app: number) {

    if (jQuery('#check_' + id_app).is(':checked')) {
      item.permiso = 1;
    } else {
      item.permiso = 0;
    }

    this.usuariosService.setAcceso(item, this.usuario.id_usuario).subscribe(
      data => {
        if (data) {

          let al: any = {
            "texto": "Acceso guardado",
            "mostrar": true
          };
          this.globalEventsManager.setAlert(al);

          this.listaaplicaciones = data.json().accesos;

          setTimeout(() => this.inicializarListaPermisos(), 500);

          console.log(this.listaaplicaciones);

        }
      }
    );
  }

  modificarPermiso(item: any, id_permiso: number) {
    if (jQuery('#check_permiso_' + id_permiso).is(':checked')) {
      item.permiso = 1;
    } else {
      item.permiso = 0;
    }

    this.usuariosService.setPermiso(item, this.usuario.id_usuario).subscribe(
      data => {
        if (data) {

          let al: any = {
            "texto": "Permiso guardado",
            "mostrar": true
          };
          this.globalEventsManager.setAlert(al);

          //this.listaaplicaciones = data.json().accesos;

        }
      }
    );

  }

  inicializarListaPermisos() {
    for (let i = 0; i < this.listaaplicaciones.length; i++) {
      for (let f = 0; f < this.listaaplicaciones[i].permisos.length; f++) {
        if (this.listaaplicaciones[i].permisos[f].permiso == 1) {
          jQuery('#check_permiso_' + this.listaaplicaciones[i].permisos[f].id_permiso).prop("checked", true);
        }
      }
    }
  }

  inicializarListaAccesos() {
    for (let i = 0; i < this.listaaccesos.length; i++) {
      if (this.listaaccesos[i].permiso == 1) {
        jQuery('#check_' + this.listaaccesos[i].id_app).prop("checked", true);
      }
    }
  }

  guardar(formulario: NgForm, event: Event) {
    this.onSubmit(formulario, event);
  }

  onSubmit(formulario: NgForm, event: Event = null) {
    event.preventDefault;

    let usuario: any;

    usuario = {
      id_user: this.usuario.id_usuario,
      nombre: this.usuario.nombre,
      apellidos: this.usuario.apellidos,
      id_empresa: this.usuario.id_empresa,
      telefono: this.usuario.telefono,
      email: this.usuario.email,
      sessionexpiretime: this.usuario.sessionexpiretime,
      activo: this.usuario.activo,
      password: this.usuario.password,
      allowip: this.usuario.allowip
    };

    this.usuariosService.setUsuario(usuario).subscribe(
      data => {
        if (data) {

          let al: any = {
            "texto": "Usuario guardado",
            "mostrar": true
          };
          this.globalEventsManager.setAlert(al);

          this.updateUsuario(data.json().usuario);
          if (this.insertonuevo) {
            this.router.navigate(['usuarios', this.usuario.id_usuario]);
          }
        }
      }
    );
  }

  refrescoChecks() {
    setTimeout(() => this.inicializarListaPermisos(), 50);
  }

  guardarRole(id_role){
    console.log(id_role);
    this.setListaRoles(id_role);
  }

}



// WEBPACK FOOTER //
// ./src/app/usuarios/usuario.component.ts